// TRANSACTION STATUS
export const DOG_PURCHASE_STATUS = {
	PR: 'PENDING REQUEST',
	A: 'APPROVED',
	DA: 'DISAPPROVED',
	CR: 'CANCELLED REQUEST',
	PP: 'PENDING PAYMENT',
	FP: 'FOR PICKUP',
	RR: 'REQUEST FOR REFUND',
	CP: 'CANCELLED PURCHASE',
	R: 'REFUNDED',
	PU: 'PICKED UP',
	F: 'FAILED',
	D: 'DELIVERED',
	MANUALLY_FAILED: "MANUALLY_FAILED",
}